import api from "./api";

const escalationService = {
  // Get all escalations with optional query params
  getAll: (params = {}) => api.get("/escalations", { params }),

  // Get statistics summary for dashboard cards
  getStats: (params = {}) => api.get("/escalations/stats", { params }),

  // Get single escalation/request detail by ID
  getById: (id) => api.get(`/escalations/${id}`),

  // Create new matter escalation or resource request (Admin, SuperAdmin)
  create: (data) => api.post("/escalations", data),

  // Update request details (Admin, if submitted)
  update: (id, data) => api.put(`/escalations/${id}`, data),

  // Super Admin takes action (approve, reject, provide resources, resolve)
  takeAction: (id, actionData) => api.patch(`/escalations/${id}/action`, actionData),

  // Post comment / timeline message
  addComment: (id, message) => api.post(`/escalations/${id}/comments`, { message }),

  // Delete escalation (if allowed)
  delete: (id) => api.delete(`/escalations/${id}`),
};

export default escalationService;
